import React, { useState, useEffect } from "react";
import { Image, Row, Col, Button, Modal } from "react-bootstrap";
import Axios from "axios";

//STYLES
import * as OrderDetailsItemStyles from "../../styles/order/orderDetailsItem";

function OrderDetailsItemDeposit(props) {
    const [pricePaid, setPricePaid] = useState(0);
    const [outstandingAmount, setOutStandingAmount] = useState(0);

    const modalDefaultValues = {
        open: false
    };

    const [modal, setModal] = useState(modalDefaultValues);

    function handleModalClose() {
        setModal(modalDefaultValues);
    }

    useEffect(() => {
        let pricePay = 0;
        if (props.item.fullyPaid == "true") {
            pricePay = props.item.fullPriceWhenOrdered * props.item.quantity;
        } else {
            pricePay = props.item.depositPriceWhenOrdered * props.item.quantity;
        }

        const fullPrice = props.item.fullPriceWhenOrdered * props.item.quantity;
        setPricePaid(pricePay);
        setOutStandingAmount(fullPrice - pricePay);
    }, []);

    function handleOpenSecondOrderConfirmation() {
        const data = { orderID: props.item.repaidOrderUUID };

        Axios.post("/pods/3dPrintingShop/orders/produceOrderConfirmationPDF", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    setModal((prevState) => {
                        return { ...prevState, open: true };
                    });
                }
            })
            .catch((err) => console.log(err));
    }

    function pdfLoaded(filename) {
        const data = { filename: filename };

        Axios.post("/pods/onlinePayments/deleteTempPDF", data)
            .then((res) => {
                const data = res.data;
            })
            .catch((err) => console.log(err));
    }

    return (
        <div>
            <div style={OrderDetailsItemStyles.body}>
                <Row>
                    <Col md="auto">
                        <Image
                            src={`/content/3dPrintingShop/products/${props.item.itemDetails.uuid.toString()}/${props.item.itemDetails.mainImage}`}
                            style={OrderDetailsItemStyles.image}
                        />
                    </Col>
                    <Col>
                        <Row>
                            <Col>
                                <strong>Name:</strong> {props.item.itemDetails.title} <br />
                                <strong>Quantity:</strong> {props.item.quantity} <br /> <br />
                                {props.item.customItem == "true" && (
                                    <div>
                                        <strong style={OrderDetailsItemStyles.customTitle}>Customisation</strong>

                                        {props.item.itemDetails.customItems.map((field, index) => {
                                            if (field.type == "text" || field.type == "dColour") {
                                                return (
                                                    <div key={index}>
                                                        {field.fieldName}: {field.fieldValue}
                                                    </div>
                                                );
                                            }
                                        })}
                                        {props.item.itemDetails.customColours && (
                                            <div>
                                                <br />
                                                <strong>Colours:</strong>
                                                {props.item.itemDetails.customItems.map((field, index) => {
                                                    if (field.type == "colour") {
                                                        return (
                                                            <div key={index}>
                                                                {field.fieldName}: {field.fieldValue}
                                                            </div>
                                                        );
                                                    }
                                                })}
                                            </div>
                                        )}
                                    </div>
                                )}
                            </Col>

                            <Col style={OrderDetailsItemStyles.columnRight}>
                                <strong>Deposit Item</strong> <br />
                                <strong>Full Price Per Item:</strong> £{(props.item.fullPriceWhenOrdered / 100).toFixed(2)} <br />
                                <strong>Deposit Price Per Item:</strong> £{(props.item.depositPriceWhenOrdered / 100).toFixed(2)} <br /> <br />
                                <strong>Price Paid: </strong> £{(pricePaid / 100).toFixed(2)} <br />
                                <span style={OrderDetailsItemStyles.redText}>
                                    <strong>To Pay:</strong> £{(outstandingAmount / 100).toFixed(2)}
                                </span>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
            <div>
                <Row>
                    <Col></Col>
                </Row>
            </div>
            {props.item.fullyPaid == "true" && (
                <div style={OrderDetailsItemStyles.bottomBox}>
                    The full amount of this item has been paid in another order{" "}
                    <Button onClick={handleOpenSecondOrderConfirmation}>View Confirmation</Button>
                </div>
            )}
            <br />
            <Modal size="lg" show={modal.open} onHide={handleModalClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Order Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <iframe
                        id="iframepdf"
                        width="100%"
                        height="500"
                        src={`${window.location.origin}/content/temp/test.pdf`}
                        onLoad={pdfLoaded.bind(this, "test.pdf")}
                    ></iframe>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleModalClose}>Close</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default OrderDetailsItemDeposit;
